import React, { useEffect, useState } from "react";

import DstButton from "../../../../../components/DstButton/DstButton";
import MultiSelectDropdown from "../../../../../components/MultiSelectDropdown/MultiSelectDropdown";
import Popup from "../../../../../components/Popup/Popup";
import { Evaluation } from "../../../../../models/Evaluation";
import translate from "../../../../../services/Translate";
import { LinkModuleEvaluationModalProps } from "./LinkModuleEvaluationModal.d";
import { fetchEvaluations, linkEvaluationToModule } from "./LinkModuleEvaluationModal.function";

const LinkModuleEvaluationModal = ({
  moduleId,
  language,
  show,
  onClose,
  onSuccess,
}: LinkModuleEvaluationModalProps) => {
  const [allEvaluations, setAllEvaluations] = useState<Evaluation[]>([]);
  const [loadingEvaluations, setLoadingEvaluations] = useState(false);
  const [selectedEvaluation, setSelectedEvaluation] = useState<Evaluation | null>(null);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (show) {
      fetchEvaluations(setAllEvaluations, setLoadingEvaluations, language);
    }
  }, [show, language]);

  const _handleClose = () => {
    setSelectedEvaluation(null);
    onClose();
  };

  return (
    <Popup
      show={show}
      onClose={_handleClose}
      modalTitle={translate(language, "PAGES.MODULE.EVALUATIONS.ADD_MODAL.TITLE")}
      size="xl"
      footerContent={
        <React.Fragment>
          <DstButton variant="secondary" value={translate(language, "GLOBAL.CANCEL")} clickFunction={_handleClose} />
          <DstButton
            value={translate(language, "GLOBAL.CONFIRM")}
            disabled={!selectedEvaluation || submitting}
            loading={submitting}
            clickFunction={() => {
              if (!selectedEvaluation) return;
              linkEvaluationToModule(
                moduleId,
                selectedEvaluation.id,
                language,
                () => {
                  _handleClose();
                  onSuccess();
                },
                setSubmitting
              );
            }}
          />
        </React.Fragment>
      }
    >
      <div className="mb-4">
        <MultiSelectDropdown
          items={allEvaluations}
          mock={loadingEvaluations}
          language={language}
          isSingleSelect
          badgeItemProperty="name"
          displayItem={(evaluation: Evaluation) => (
            <span>
              {evaluation.name} <span className="dark-gray-font">({evaluation.s3_name})</span>
            </span>
          )}
          toggleClass={`w-100 border ${!selectedEvaluation ? "text-muted" : ""}`}
          label={
            selectedEvaluation?.name || translate(language, "PAGES.MODULE.EVALUATIONS.ADD_MODAL.SELECT_EVALUATION")
          }
          onConfirm={(selected: Evaluation[]) => setSelectedEvaluation(selected.length ? selected[0] : null)}
          borderToggle
          btnWidth="100%"
        />
      </div>
    </Popup>
  );
};

export default LinkModuleEvaluationModal;
